var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketIllustration2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1074,
    height: 971,
    viewBox: "0 0 1074 971",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M623.318 308.131H582.114V779.097H623.318V308.131Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4301_4643",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 679,
    width: 1212,
    height: 293
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1211.74 679.666H0.116699V971H1211.74V679.666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4301_4643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1132.6 1151.29C1192.08 1091.81 1192.08 995.372 1132.6 935.892C1073.12 876.413 976.687 876.413 917.208 935.892C857.729 995.371 857.729 1091.81 917.208 1151.29C976.687 1210.76 1073.12 1210.76 1132.6 1151.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.042 1121.96C857.256 1121.96 951.465 1027.75 951.465 911.541C951.465 795.328 857.256 701.119 741.042 701.119C624.829 701.119 530.62 795.328 530.62 911.541C530.62 1027.75 624.829 1121.96 741.042 1121.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.528 1151.29C338.007 1091.81 338.007 995.373 278.528 935.894C219.049 876.415 122.615 876.415 63.1357 935.894C3.65673 995.373 3.65676 1091.81 63.1358 1151.29C122.615 1210.77 219.049 1210.77 278.528 1151.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.693 1121.96C570.906 1121.96 665.116 1027.75 665.116 911.541C665.116 795.328 570.906 701.119 454.693 701.119C338.48 701.119 244.271 795.328 244.271 911.541C244.271 1027.75 338.48 1121.96 454.693 1121.96Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4301_4643)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M541.041 261.484L504.493 305.774C493.604 318.617 487.597 334.891 487.532 351.735L480.645 521.375L550.479 384.904L541.041 261.497V261.484Z",
    fill: "#064259"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.54
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M541.041 261.484L530.425 274.003L515.562 453.146L548.213 389.319L541.041 261.484Z",
    fill: "#569DEF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M660.746 261.484L697.294 305.774C708.182 318.617 714.19 334.891 714.254 351.735L721.155 521.362L651.321 384.891L660.759 261.484H660.746Z",
    fill: "#064259"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.54
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M660.746 261.484L671.349 274.003L686.212 453.146L653.56 389.319L660.746 261.484Z",
    fill: "#569DEF"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M567.931 437.455L557.38 468.462C557.38 468.462 599.172 489.436 646.44 468.19L635.694 437.248L567.931 437.455Z",
    fill: "#090916"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M603.198 18.7209C602.473 18.1771 601.45 18.3584 600.881 19.0575C595.08 26.3335 564.008 69.5883 549.676 177.564C529.441 330.14 534.71 438.555 534.71 438.555C534.71 438.555 601.644 461.562 668.436 438.141C668.436 438.141 666.378 269.666 652.745 172.605C641.908 95.4687 615.031 27.6152 603.198 18.7209Z",
    fill: "#A9ECFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4301_4643",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 534,
    y: 18,
    width: 135,
    height: 431
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M603.198 18.7209C602.473 18.1771 601.45 18.3584 600.881 19.0575C595.08 26.3335 564.008 69.5883 549.676 177.564C529.441 330.14 534.71 438.555 534.71 438.555C534.71 438.555 601.644 461.562 668.436 438.141C668.436 438.141 666.378 269.666 652.745 172.605C641.908 95.4687 615.031 27.6152 603.198 18.7209Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4301_4643)"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M554.583 79.3631C554.583 79.3631 600.117 121.064 651.541 79.0653L604.609 0L554.583 79.3631Z",
    fill: "#064259"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.24
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M601.968 12.8819L604.091 470.585L681.085 448.9C681.085 448.9 695.093 69.9897 601.968 12.8819Z",
    fill: "#B5B6B7"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M634.059 213.579C641.373 195.357 632.53 174.657 614.309 167.343C596.087 160.029 575.387 168.871 568.073 187.093C560.759 205.314 569.601 226.015 587.823 233.329C606.044 240.643 626.745 231.8 634.059 213.579Z",
    fill: "#064259"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M626.165 200.272C626.204 214.125 615.005 225.401 601.152 225.44C587.299 225.479 576.023 214.28 575.984 200.427C575.945 186.574 587.144 175.298 600.997 175.259C614.85 175.22 626.127 186.419 626.165 200.272Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M601.955 254.583C601.955 254.583 597.631 268.048 596.44 327.991C595.249 387.921 599.961 533.921 599.961 533.921L607.431 533.895L607.224 327.81C607.224 327.81 606.525 278.133 601.968 254.583H601.955Z",
    fill: "#064259"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4301_4643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240.484,
    height: 533.921,
    fill: "white",
    transform: "translate(480.645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIllustration2);
export default __webpack_public_path__ + "static/media/rocket-illustration-2.8cd1ae0b95a9c0f18e75918ed587218a.svg";
export { ForwardRef as ReactComponent };